import styled from "styled-components";

export const Card = styled.div`
  flex: 1;
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow-x: hidden;
  align-items: stretch;
  ${({
    margin,
    padding = "0.5rem",
    size = 1,
    theme: { breakpoint, colors },
  }) => `
    margin: ${margin};
    padding: ${padding};
    flex: ${size};
    border: 1px solid ${colors("foreground", 0.1)};
    background: ${colors("shadow", 0.2)};
    &.tile {
      background: ${colors("foreground", 0.05)};
      border-color: ${colors("foreground", 0.08)};
      padding: 0;
    }
    @media only screen and (min-width: ${breakpoint("sm")}) {
      margin: ${margin || "1vw"};
    }
  `}
`;
